// src/utils/programmaPM.js — copia identica di functions/programmaPM.js (le functions non
// possono importare da src): stessa regola per la Home del PM e per l'email della domenica.
// La prova demo/prove/prova_programma_pm.mjs controlla che diano lo stesso risultato.
// ═══════════════════════════════════════════════════════════════════════════
// PROGRAMMA LAVORI DELLE COMMESSE DI UN PM (ottobre 2026, W424)
// ═══════════════════════════════════════════════════════════════════════════
// Dalla Programmazione settimanale: righe = commesse, colonne = giorni, celle = persone.
// Regole decise con Paolo:
//  • commesse del PM = quelle di cui è responsabile (responsabileUid); titolare e admin: tutte;
//  • solo i giorni pubblicati (giornoPubblicato), salvo per chi programma;
//  • le righe nascoste da chi programma (privacy.righeNascoste, riga del titolare se non
//    mostrata) non compaiono;
//  • niente furgoni: ai PM non interessano (li vedono gli operativi in Programmazione);
//  • sabato e domenica solo se qualcuno è programmato.
// ═══════════════════════════════════════════════════════════════════════════
const ASSENZE = ["Ferie", "Permesso", "Malattia"];
const pad2 = (n) => String(n).padStart(2, "0");
const ds = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

export function giornoPubblicato(mappa, dateStr, privacy) {
  const v = mappa ? mappa[dateStr] : undefined;
  if (v === true) return true;
  if (v === false) return false;
  const dal = privacy && privacy.giorniPrivatiDal;
  if (!(privacy && privacy.giorniNuoviPrivati === false) && dal && dateStr >= dal) return false;
  return true;
}

/**
 * @param p {
 *   lunedi: Date, programmazione: { celle, pubblicati }, privacy, progetti: [{ id, name, codiceCommessa, clienteNome, responsabileUid }],
 *   utenti: [{ uid, displayName }], pmUid: string | null (null = tutte le commesse), vedeNonPubblicati: bool }
 * @returns { giorni: [{ data, etichetta, pubblicato }], righe: [{ projectId, codice, nome, cliente, celle: { data: [nomi] } }], assegnazioni }
 */
export function programmaPM({ lunedi, programmazione, privacy = {}, progetti = [], utenti = [], pmUid = null, vedeNonPubblicati = false }) {
  const nomi = new Map(utenti.map(u => [u.uid, u.displayName || u.nome || ""]));
  const nascoste = new Set(privacy.righeNascoste || []);
  const proprietario = privacy.mostraRigaOwner ? null : privacy.ownerUid || null;
  const mie = new Map(progetti.filter(p => !p.isParent && (!pmUid || p.responsabileUid === pmUid)).map(p => [p.id, p]));
  const tutti = [];
  for (let i = 0; i < 7; i++) { const d = new Date(lunedi.getFullYear(), lunedi.getMonth(), lunedi.getDate() + i); tutti.push(d); }
  const pubblicati = (programmazione && programmazione.pubblicati) || {};
  const visibile = (data) => vedeNonPubblicati || giornoPubblicato(pubblicati, data, privacy);
  const righe = new Map();
  let assegnazioni = 0;
  Object.entries((programmazione && programmazione.celle) || {}).forEach(([chiave, voce]) => {
    const data = (chiave.match(/(\d{4}-\d{2}-\d{2})$/) || [])[1];
    if (!data || !visibile(data)) return;
    (Array.isArray(voce) ? voce : voce && typeof voce === "object" ? [voce] : []).forEach(v => {
      const uid = v.uid || chiave.split("_")[0];
      if (!v.commessaId || ASSENZE.includes(v.commessaNome) || !mie.has(v.commessaId)) return;
      if (nascoste.has(uid) || (proprietario && uid === proprietario)) return;
      const p = mie.get(v.commessaId);
      if (!righe.has(p.id)) righe.set(p.id, { projectId: p.id, codice: p.codiceCommessa || "", nome: p.name || v.commessaNome || "", cliente: p.clienteNome || "", celle: {} });
      const r = righe.get(p.id);
      const nome = nomi.get(uid) || v.dipNome || "Collaboratore";
      r.celle[data] = r.celle[data] || [];
      if (!r.celle[data].includes(nome)) { r.celle[data].push(nome); assegnazioni++; }
    });
  });
  const elenco = [...righe.values()].sort((a, b) => (a.codice || a.nome).localeCompare(b.codice || b.nome, "it", { numeric: true }));
  elenco.forEach(r => Object.values(r.celle).forEach(l => l.sort((a, b) => a.localeCompare(b, "it"))));
  const giorni = tutti.filter((d, i) => i < 5 || elenco.some(r => r.celle[ds(d)]))
    .map(d => ({ data: ds(d), etichetta: d.toLocaleDateString("it-IT", { weekday: "short", day: "numeric", month: "short" }), pubblicato: giornoPubblicato(pubblicati, ds(d), privacy) }));
  return { giorni, righe: elenco, assegnazioni };
}

/** Lunedì della settimana di d (a mezzanotte locale). */
export function lunediDi(d) {
  const l = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  l.setDate(l.getDate() - ((l.getDay() + 6) % 7));
  return l;
}
export const idSettimana = (orgId, lunedi) => `${orgId}_${lunedi.getFullYear()}${pad2(lunedi.getMonth() + 1)}${pad2(lunedi.getDate())}`;

